import { QueryClient } from '@tanstack/react-query';

/**
 * The app's one query cache. Vendor queries are keyed without the tenant or vendor (the backend
 * scopes them by the session cookie), so the cache must be emptied whenever the signed-in user
 * changes - otherwise the next login is shown the previous user's data. See services/api.ts.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
